export enum EidType {
  Unknown = 'unknown',
  BankId = 'bankid',
}
